// Lazy Load images
const images = document.querySelectorAll('img[data-src]');

for (let i = 0; i < images.length; i += 1) {
	const img = images[i];

	img.setAttribute('src', img.getAttribute('data-src'));
	img.onload = () => img.removeAttribute('data-src');
}
